// Confirmation dialog shown before a PRF's approvals are discarded.
//
// Both PRF detail pages render the window markup (see _PrfReopenConfirmation.cshtml) and this
// module drives it. The [data-role=openKendoWindow] auto-wiring only opens and closes a window,
// whereas confirming here has to run an action - post the removal, then navigate - so the
// handlers are bound explicitly.

import { REOPEN_CONFIRMATION_WINDOW_ID } from './prf-window-ids';

export { REOPEN_CONFIRMATION_WINDOW_ID };

/**
 * Asks the user to confirm discarding a PRF's approvals, then runs @onConfirm.
 *
 * Handlers are rebound on every call so that pressing the reopen button twice cannot stack
 * them, and so a second call always acts on the latest @onConfirm.
 *
 * @param {Function} onConfirm invoked only if the user confirms.
 */
export const confirmReopen = (onConfirm) => {
    const $window = $(`#${REOPEN_CONFIRMATION_WINDOW_ID}`);
    const k_window = $window.data('kendoWindow');

    // Fallback for a page that did not render the dialog. Discarding approvals must always be
    // confirmed, so ask through the browser rather than silently proceeding.
    if (!k_window) {
        if (window.confirm('Remove all approvals and open this Pursuit Request Form for editing?')) {
            onConfirm();
        }
        return;
    }

    const $confirm = $window.find('.js-prf-reopen-confirm');
    const $cancel = $window.find('.js-prf-reopen-cancel');

    $confirm.off('click.prfReopen').on('click.prfReopen', function () {
        k_window.close();
        onConfirm();
    });

    $cancel.off('click.prfReopen').on('click.prfReopen', function () {
        k_window.close();
    });

    k_window.open();
};
